import React, { FunctionComponent } from 'react';

import {Loading} from "../components";

interface PreviewImageProps {
  image: string | undefined;
  loading: boolean;
  thumbnail: string;
}

const PreviewImage: FunctionComponent<PreviewImageProps> = ({
  image,
  loading,
  thumbnail
}: PreviewImageProps) => {
  if (loading) {
    return <Loading className="view-preview-image"/>;
  } else if (!image && !thumbnail) {
    return null;
  }

  return (
    <div className="tableau-embed-form__preview-image">
      <img src={image ? image : thumbnail} alt="Thumbnail Preview" />
    </div>
  );
};

export default PreviewImage;
